// Libs
import intersection from 'lodash/intersection';
// App
import { AUTHORITY } from '../account';
import { Session } from './auth.interfaces';

/**
 * Check if user has specified authority
 * @param session the session of user
 * @param authority the authority to check
 * @returns true if user has specified authority, false else
 */
export const hasAuthority = (session: Session, authority: AUTHORITY): boolean => {
  if (!session || !session.user || !session.user.auth) {
    return false;
  }

  const userAutorities: string[] = session.user.auth.split(',');

  return userAutorities.includes(authority);
};

/**
 * Checks if user has at leat one of specified authorities
 * @param session the session of user
 * @param authorities the authorities to check
 * @returns true if user has at leat one of specified authorities, false else
 */
export const hasAtLeastOneOfAuthorities = (session: Session, authorities: AUTHORITY[]): boolean => {
  if (!session || !session.user || !session.user.auth) {
    return false;
  }

  const userAutorities = session.user.auth.split(',');

  return intersection(authorities, userAutorities).length > 0;
};

/**
 * Builds authorization header from session
 * @param session the session of user
 * @returns the header
 */
export const buildAutorizationHeader = (session: Session): string => {
  if(!session) return "";

  const accessToken = session && session.accessToken;

  return `Bearer ${accessToken}`;
}
